import { gql } from '@apollo/client';

export const CART_BILLING_ADDRESS_FRAGMENT = gql`
  fragment CartBillingAddressDetails on Magento2_BillingCartAddress {
    firstname
    lastname
    street
    city
    company
    region {
      regionId
    }
    postcode
    country {
      code
    }
    telephone
    __typename
  }
`;

export const CART_SHIPPING_ADDRESS_FRAGMENT = gql`
  fragment CartShippingAddressDetails on Magento2_ShippingCartAddress {
    firstname
    lastname
    street
    city
    company
    region {
      regionId
    }
    postcode
    country {
      code
    }
    telephone
    __typename
  }
`;

export const SET_SHIPPING_ADDRESS = gql`
  ${CART_SHIPPING_ADDRESS_FRAGMENT}

  mutation SetShippingAddress($cartId: String!, $shippingAddressId: Int!) {
    magento2 {
      setShippingAddressesOnCart(
        input: {
          cart_id: $cartId
          shipping_addresses: [{ customer_address_id: $shippingAddressId }]
        }
      ) {
        cart {
          id
          shippingAddresses {
            ...CartShippingAddressDetails
          }
        }
      }
    }
  }
`;

export const SET_BILLING_ADDRESS = gql`
  ${CART_BILLING_ADDRESS_FRAGMENT}

  mutation SetBillingAddress(
    $cartId: String!
    $billingAddressId: Int!
    $sameAsShipping: Boolean
  ) {
    magento2 {
      setBillingAddressOnCart(
        input: {
          cart_id: $cartId
          billing_address: {
            customer_address_id: $billingAddressId
            same_as_shipping: $sameAsShipping
          }
        }
      ) {
        cart {
          id
          billingAddress {
            ...CartBillingAddressDetails
          }
        }
      }
    }
  }
`;
